import React, {useRef, useEffect, useMemo} from 'react'
import * as d3 from 'd3'
import styles from './Circle.module.css'

export const Circle = ({wins,losses,remakes}) =>{
  const chart = useRef(null)
  const data = useMemo(()=>{return[wins,losses,remakes]},[wins,losses,remakes])
  const wr = (wins+losses) ? Math.round(wins/(wins+losses)*100) : 0;
  useEffect(() => {
    let canvas = chart.current
    const context = canvas.getContext("2d")

    let radius = 98;
    canvas.width = 200
    canvas.height = 200
    const colors = ["#7bcc7b","#cc7b7b","#cccccc"]
    
    var arc = d3.arc()
        .outerRadius(radius - 1)
        .innerRadius(radius - 40)
        .padAngle(0.05)
        .context(context)
    
    var pie = d3.pie();
    var arcs = pie(data)
    context.translate(100, 100)
    
    context.globalAlpha = 0.5
    arcs.forEach(function(d, i) {
      if (!remakes && i===2) return
      context.beginPath()
      arc(d)
      context.fillStyle = colors[i]
      context.fill()
    })

    context.globalAlpha = 1
    arcs.forEach((d, i) => {
      if (!remakes && i===2) return
      context.beginPath()
      arc(d)
      context.lineWidth = 3
      context.strokeStyle = colors[i]
      context.stroke()
    })
  },[data,remakes])

  return (
    <div className={styles.circle}>
      <canvas ref={chart}></canvas>
      <div className={wr>=50 ? styles.green : styles.red}>{wr}%</div>
    </div>
  )
}
export default Circle
